import React from 'react';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { Text } from '@amzn/atoz-web/Text';
import { Col } from '@amzn/atoz-web/Col';
import { useTranslation } from 'react-i18next';
import { useVTOAccepted } from './useVTOAccepted';
export var VTOAccepted = function (_a) {
    var scheduleShift = _a.scheduleShift;
    var t = useTranslation().t;
    var vtoAcceptedLines = useVTOAccepted(scheduleShift);
    return (React.createElement(React.Fragment, null, !!(vtoAcceptedLines === null || vtoAcceptedLines === void 0 ? void 0 : vtoAcceptedLines.length) && (React.createElement(Col, { dataTestId: "VTOAccepted", gridGap: "S200" }, vtoAcceptedLines.map(function (vtoLine, i) {
        return (React.createElement(MessageBanner, { key: "VTOAccepted-".concat(i), type: MessageBannerType.Success },
            React.createElement(Text, null, t('shift_management_features_ShiftDetailsModalButtonView_vtoAccepted', {
                intervalStr: vtoLine.intervalStr,
                durationStr: vtoLine.durationStr
            }))));
    })))));
};
